import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Radio,
  RadioGroup,
  Tooltip
} from '@mui/material';
import { GridFooter, GridFooterContainer, GridLinkOperator } from '@mui/x-data-grid-pro';
import axios from 'axios';
import { saveAs } from 'file-saver';
import React, { useEffect, useState } from 'react';
import config from 'src/appConfig';
import { store } from 'src/store';
import { useAppSelector } from 'src/store/hooks';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { DataGridComponent } from '../common/DataGridComponent';
import { GridComponent } from '../common/GridComponent';
import { usePermissionWrapper } from '../common/hooks/usePermissionWrapper';
import { PopupComponent } from '../common/PopupComponent';
//import { SearchHierarchy } from '../common/hierarchy/SearchHierarchy';
import { TreeViewComponent } from '../common/treeview/TreeViewComponent';
import { DocumentUpload } from '../eTMF/documentUpload/DocumentUpload';
import DocManagementService from '../eTMF/documentUpload/service/DocManagementService';
import AuditHistory from '../eTMF/documentViewer/AuditHistory';
import DocumentViewerComponent from '../eTMF/documentViewer/DocumentViewer';
import VersionHistory from '../eTMF/documentViewer/VersionHistory';
import SendasLink from '../eTMF/modelViewer/SendasLink';
import SearchHierarchy from '../layouts/DashboardLayout/SearchHierarchy';
import { CustomToolbar } from './CustomToolBar';
import { RecentDocuments } from './RecentDocuments';
import { useColumns } from './useColumns';
import { useViewer } from './useViewer';
import { CustomPagination } from 'src/util/DataTableFooter';
import { useGetStudiesQuery } from '../Services/Utils';
import { useSnackbar, VariantType } from 'notistack';
import { hideLoader, showLoader } from 'src/store/Loader';
import { Loader } from 'src/components/common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from 'src/store';

export interface IViewer {
  routeInfo?: (route: string) => void;
  onClicked?: boolean;
}

export const Viewer: React.FC<IViewer> = props => {
  const {
    expanded,
    toggle,
    binderViewTitle,
    treeItemClick,
    treeViewData,
    recentDocumentClick,
    recentDocuments,
    recentDocumentsHeading,
    apiRef,
    documents,
    pageSize,
    setPageSize,
    columnVisibilityModel,
    setColumnVisibilityModel,
    getLoadingState,
    getSelectedData,
    items,
    documentToDisplay,
    dataGridComponent,
    gethashedurikey,
    onGridLinkClick,
    handleClick,
    anchorEl,
    handleClose,
    openAuditTrail,
    setOpenAuditTrail,
    setAnchorEl,
    openSendAsLinkDialog,
    setOpenVersionHistory,
    openVersionHistory,
    setSendAsLinkDialog,
    fileId,
    setFileId,
    setDocumentToDisplay,
    setDataGridComponent,
    artifactList,
    selectedRowDocumentDetails,
    getRecentDocs,
    docUploadComponent,
    setDocUploadComponent,
    getAllDoc,
    pageNumber,
    setPageNumber,
    rowCount
  } = useViewer(props);

  const { columns } = useColumns({
    anchorEl,
    artifactList,
    gethashedurikey,
    handleClick,
    handleClose,
    onGridLinkClick
  });

  const { checkPermission } = usePermissionWrapper();
  const user: any = useAppSelector(state => state.user.user);
  const Sponsor = user?.sponsor ? user.sponsor.toUpperCase() : '';

  const setSearchData = (study: string, country: string, site: string) => {
    getSelectedData({
      sponsor: Sponsor,
      study: study === '--' ? '' : study,
      country: country === '--' ? '' : country,
      site: site === '--' ? '' : site
    });
  };
  const isDataAvailable: any = useAppSelector(state => state.user.user?.userdataavailable);

  const [displayDoc, setDisplayDoc] = useState<boolean>(false);
  const docService = new DocManagementService();

  useEffect(() => {
    getRecentDocs();
  }, [displayDoc]);

  // for Send to ISF Dialog
  const [openSend, setOpenSend] = React.useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [checked, setChecked] = useState<boolean>(false);
  const [noOfRows, setNoOfRows] = useState<any>([]);
  const [openVersion, setOpenVersion] = useState(false);
  const [editedFmID, setEditedFmID] = useState('');
  const [allNewFiles, setAllNewFiles] = useState([]);
  const [isfToBePublishedFiles, setIsfToBePublishedFiles] = useState([]);
  const [selectedRows, setSelectedRows] = React.useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [overwrite, setOverwrite] = useState<boolean>(false);
  const [selectionModel, setSelectionModel] = useState([]);
  const [isEnable, setIsEnable] = useState<boolean>(true);
  const [loadingSendToISF, setLoadingSendToISF] = useState<boolean>(false);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const isLoaderLoading: any = useSelector((state: AppState) => state.loader.isLoading);
  const [loaderStatus, setLoaderStatus] = useState(isLoaderLoading);
  useEffect(() => {
    setLoaderStatus(isLoaderLoading);
  }, [isLoaderLoading]);
  const filterFiles = async () => {
    dispatch(showLoader());
    if (selectedFiles.length > 0) {
      const tempNewFiles: any = [];
      selectedFiles.forEach((file: any) => {
        if (file.sent_to_isf === false) {
          tempNewFiles.push(file);
        }
      });
      const newVersionFiles: any = [];
      const overwriteOrNewVersionFiles: any = [];
      if (tempNewFiles.length > 0) {
        const payload = { tmf_document_ids: tempNewFiles.map((file: any) => file.tmf_document_id) };
        const resp: any = await docService.VersionBasedDocument(payload);
        if (resp.data && resp.data.length > 0) {
          tempNewFiles.forEach((file: any) => {
            if (resp.data.find((resFile: any) => resFile.tmf_document_id === file.tmf_document_id)) {
              overwriteOrNewVersionFiles.push(file);
            } else {
              newVersionFiles.push(file);
            }
          });
          setAllNewFiles(newVersionFiles);
        } else {
          setAllNewFiles(tempNewFiles);
        }
        setIsfToBePublishedFiles(overwriteOrNewVersionFiles);
      }

      if (overwriteOrNewVersionFiles.length === 0 && (newVersionFiles.length > 0 || tempNewFiles.length > 0)) {
        const fileIds = (newVersionFiles.length > 0 ? newVersionFiles : tempNewFiles)
          .filter((item: any) => item)
          .map((item: any) => item.id);
        const data = { doucment_id: [...fileIds] };
        const response = await docService.BulkUpload(false, 'Search', data);
        if (response.data) {
          if (
            response.data.pushed_documents.doucment_name?.length > 0 ||
            response.data.multiple_mapped_documents.doucment_name?.length > 0
          ) {
            if (response.data.pushed_documents.doucment_name?.length > 0) {
              const variant: VariantType = 'success';
              enqueueSnackbar(`Document(s) sent to ISF successfully.`, {
                variant
              });
            }
            if (response.data.multiple_mapped_documents.doucment_name?.length > 0) {
              const variant: VariantType = 'info';
              enqueueSnackbar(
                `The selected ${response.data.multiple_mapped_documents.doucment_name?.join(
                  ','
                )} artifact is mapped to multiple artifacts. Please go to the individual document send to ISF option to complete the activity`,
                {
                  variant
                }
              );
            }
            getAllDoc();
            onSelectionModelChange([]);
          } else {
            store.dispatch(
              setSnackbarMessage('None of the selected documents are eligible to be sent to ISF', 'error')
            );
          }
        } else {
          store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to ISF', 'error'));
        }
      } else if (newVersionFiles.length === 0 && tempNewFiles.length === 0) {
        store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to ISF', 'error'));
      } else {
        setOpenSend(true);
      }
    } else {
      store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to ISF', 'error'));
    }
    setLoadingSendToISF(false);
    dispatch(hideLoader());
  };

  const onSelectionModelChange = (ids: any) => {
    setSelectionModel(ids);
    const selectedIds = new Set(ids);
    const filesSelected: any = items
      .filter((row: any) => selectedIds.has(row.id))
      .filter(
        (elem: any) =>
          elem.tmf_doc_status === 'Approved' &&
          elem.need_to_sent_to_isf === 'Yes' &&
          elem.tmf_doc_viewer_ref_model_version.slice(0, 3) === 'TMF' &&
          elem.tmf_doc_level === 'Site' &&
          elem.tmf_doc_version_number % 1 === 0
      );

    setSelectedFiles(filesSelected);
    const rowSelected = items.filter((row: any) => selectedIds.has(row.id)).map((elem: any) => elem.fileId);
    setNoOfRows(rowSelected);
    setSelectedRows(rowSelected);
  };
  const handleRadioValue = (e: any, value: any) => {
    setChecked(true);
    if (value === 'newVersion') {
      setOverwrite(false);
    } else {
      setOverwrite(true);
    }
  };

  const handleClickOpenSend = () => {
    if (noOfRows.length > 10) {
      return store.dispatch(setSnackbarMessage('Maximum 10 documents are allowed to be sent to ISF at once', 'error'));
    } else {
      setLoadingSendToISF(true);
      filterFiles();
    }
  };
  const handleCloseSendToISF = () => {
    setChecked(false);
    setOpenSend(false);
  };
  const handleCloseSend = async () => {
    dispatch(showLoader());
    let response1: any = [];
    let response2: any = [];

    if (isfToBePublishedFiles.length > 0) {
      if (overwrite) {
        response1 = await docService.BulkUpload(true, 'Search', {
          doucment_id: isfToBePublishedFiles.map((file: any) => file.id)
        });
      } else {
        response1 = await docService.BulkUpload(false, 'Search', {
          doucment_id: isfToBePublishedFiles.map((file: any) => file.id)
        });
      }
    }
    if (allNewFiles.length > 0) {
      response2 = await docService.BulkUpload(false, 'Search', {
        doucment_id: allNewFiles.map((file: any) => file.id)
      });
    }

    const pushedDocsLists: string[] = [];
    const mappedMultiDocsLists: string[] = [];
    if (response1.data || response2.data) {
      response1.data &&
        response1.data.pushed_documents.doucment_name &&
        pushedDocsLists.push(response1.data.pushed_documents.doucment_name);
      response1.data &&
        response1.data.multiple_mapped_documents.doucment_name &&
        mappedMultiDocsLists.push(response1.data.multiple_mapped_documents.doucment_name);
      response2.data &&
        response2.data.pushed_documents.doucment_name &&
        pushedDocsLists.push(response2.data.pushed_documents.doucment_name);
      response2.data &&
        response2.data.multiple_mapped_documents.doucment_name &&
        mappedMultiDocsLists.push(response2.data.multiple_mapped_documents.doucment_name);
    }
    if (pushedDocsLists.length > 0 || mappedMultiDocsLists.length > 0) {
      if (pushedDocsLists.length > 0) {
        const variant: VariantType = 'success';
        enqueueSnackbar(`Document(s) sent to ISF successfully.`, {
          variant
        });
      }
      if (mappedMultiDocsLists.length > 0) {
        const variant: VariantType = 'info';
        enqueueSnackbar(
          `The selected ${mappedMultiDocsLists?.join(
            ','
          )} artifact is mapped to multiple artifacts. Please go to the individual document send to ISF option to complete the activity`,
          {
            variant
          }
        );
      }
      getAllDoc();
      onSelectionModelChange([]);
    } else {
      store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to ISF', 'error'));
    }
    setOpenSend(false);
    dispatch(hideLoader());
  };

  useEffect(() => {
    if (selectedRows.length > 0) {
      setIsEnable(false);
    } else {
      setIsEnable(true);
    }
  }, [selectedRows]);

  const url = `${config.appConfig.apietmf}/fileMaster/downloadFiles?application=ETMF&module_section_related=TMF%20Binder%20Viewer&log=Y&original=N&bulk_download=true`;
  const payload: any = {
    id: selectedRows
  };

  const axiosOptions: any = {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json'
    }
  };

  const handleBulkDownload = (url: any) => {
    if (selectedRows.length > 10) {
      return store.dispatch(setSnackbarMessage('Maximum 10 documents are allowed to download at once', 'error'));
    } else {
      setLoading(true);
      axios
        .post(url, payload, axiosOptions)
        .then(response => {
          const blob = new Blob([response.data], {
            type: 'application/octet-stream'
          });
          const filename = 'TMF_Binder_Viewer_Bulk_Download.zip';
          saveAs(blob, filename);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
        });
    }
  };
  const { isLoading: getStudyLoad } = useGetStudiesQuery();

  if (loading)
    return (
      <>
        <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={loading}>
          <CircularProgress />
        </Backdrop>
      </>
    );

  // for Custom buttons at Data Grid
  function CustomFooterButtons() {
    return (
      <GridFooterContainer>
        <Box sx={{ p: 1, display: 'flex', columnGap: 1 }} className="customFtBtnWrap">
          {checkPermission('bulk_download') && (
            <Button variant="outlined" onClick={() => handleBulkDownload(url)} disabled={isEnable}>
              Download
            </Button>
          )}
          <Tooltip
            placement="top"
            title="Only documents configured to be sent to ISF in 'Planning' and those in 'Approved' status will be sent to ISF"
          >
            <Button
              variant="outlined"
              onClick={handleClickOpenSend}
              className={checkPermission('send_to_isf') ? '' : 'hide'}
              disabled={noOfRows.length <= 0 || loadingSendToISF}
              sx={{ minWidth: 112 }}
            >
              Send to ISF
            </Button>
          </Tooltip>
        </Box>

        <GridFooter />
      </GridFooterContainer>
    );
  }

  return (
    <React.Fragment>
      {dataGridComponent ? (
        <React.Fragment>
          {docUploadComponent ? (
            <div>
              <div>
                <SearchHierarchy searchData={setSearchData} />
                {/* <SearchHierarchy getLoadingState={getLoadingState} getSelectedData={getSelectedData}></SearchHierarchy> */}
                {isDataAvailable != null && isDataAvailable === false && !getStudyLoad ? (
                  <div className="no-data-class">
                    <h3>No Data access available!</h3>
                  </div>
                ) : (
                  <>
                    <GridComponent container className="model-viewer-page">
                      <GridComponent md={12}>
                        <GridComponent container>
                          <GridComponent md={4} xl={3}>
                            <h4>{binderViewTitle}</h4>
                            <TreeViewComponent
                              expanded={expanded}
                              toggle={toggle}
                              treeitemclick={treeItemClick}
                              treeViewData={treeViewData}
                            ></TreeViewComponent>
                          </GridComponent>
                          <GridComponent md={8} xl={9}>
                            <RecentDocuments
                              handleClick={recentDocumentClick}
                              items={recentDocuments}
                              heading={recentDocumentsHeading}
                            ></RecentDocuments>
                            <div
                              className="tmf-binder-viewer"
                              style={{ minHeight: '59vh', height: 'calc(100% - 100px)', width: '100%' }}
                            >
                              <DataGridComponent
                                apiRef={apiRef}
                                rows={items}
                                columns={columns}
                                checkboxSelection
                                checkboxSelectionVisibleOnly={true}
                                selectionModel={selectionModel}
                                onSelectionModelChange={onSelectionModelChange}
                                disableSelectionOnClick
                                page={pageNumber}
                                onPageChange={newPage => setPageNumber(newPage)}
                                rowCount={rowCount}
                                pageSize={pageSize}
                                onPageSizeChange={newPageSize => setPageSize(newPageSize)}
                                rowsPerPageOptions={[10, 20, 30]}
                                pagination
                                disableColumnSelector={false}
                                components={{
                                  Toolbar: CustomToolbar,
                                  Footer: CustomFooterButtons,
                                  Pagination: CustomPagination
                                }}
                                initialState={{
                                  sorting: {
                                    sortModel: [{ field: 'tmf_document_name', sort: 'asc' }]
                                  }
                                }}
                                columnVisibilityModel={columnVisibilityModel}
                                onColumnVisibilityModelChange={(newModel: any) => {
                                  setColumnVisibilityModel(newModel);
                                }}
                                componentsProps={{
                                  filterPanel: {
                                    linkOperators: [GridLinkOperator.And, GridLinkOperator.Or],
                                    items: [
                                      { id: 1, columnField: 'tmf_doc_version_number', operatorValue: '>', value: '' }
                                    ]
                                  }
                                }}
                                className="Binder_DataGrid"
                              />
                            </div>
                          </GridComponent>
                        </GridComponent>
                      </GridComponent>
                    </GridComponent>
                  </>
                )}
              </div>
              {openAuditTrail && (
                <AuditHistory
                  openAuditTrail={openAuditTrail}
                  setOpenAuditTrail={setOpenAuditTrail}
                  setAnchorEl={setAnchorEl}
                  setFileId={setFileId}
                />
              )}
              {openVersionHistory && (
                <VersionHistory
                  openVersionHistory={openVersionHistory}
                  setOpenVersionHistory={setOpenVersionHistory}
                  setAnchorEl={setAnchorEl}
                  setFileId={setFileId}
                  dataGridComponent={dataGridComponent}
                  setDataGridComponent={setDataGridComponent}
                  setDocumentToDisplay1={setDocumentToDisplay}
                />
              )}
              {openSendAsLinkDialog && (
                <SendasLink
                  openSendAsLinkDialog={openSendAsLinkDialog}
                  setSendAsLinkDialog={setSendAsLinkDialog}
                  setAnchorEl={setAnchorEl}
                  setFileId={setFileId}
                  documentDetails={selectedRowDocumentDetails}
                />
              )}
            </div>
          ) : (
            <div>{<DocumentUpload setDocUploadComponent={setDocUploadComponent} />}</div>
          )}
        </React.Fragment>
      ) : (
        <div>
          {documentToDisplay && (
            <DocumentViewerComponent
              documentDetails={documentToDisplay}
              props={props}
              setDataGridComponent={setDataGridComponent}
              setOpenVersion={setOpenVersion}
              setEditedFmID={setEditedFmID}
            />
          )}
        </div>
      )}
      {/* -- for Send to ISF Dialog Disclaimer -- */}
      {/* {openPopup && <DisclaimerPopup openPopup={openPopup} setOpenPopup={setOpenPopup} />} */}

      {/* -- for Send to ISF Dialog -- */}
      <PopupComponent open={openSend}>
        <Loader open={loaderStatus} />
        <DialogTitle>Send to ISF</DialogTitle>
        <DialogContent className="sendToDialog">
          <DialogContentText>The following documents already exist in ISF:</DialogContentText>
          <Paper sx={{ width: '100%', maxHeight: 242, bgcolor: 'background.paper', overflowY: 'auto' }}>
            <List dense={true}>
              {isfToBePublishedFiles.map((item: any) => {
                return (
                  <ListItem disablePadding key={item.id}>
                    <ListItemButton>
                      <ListItemText primary={item.tmf_document_name} />
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          </Paper>

          <FormControl>
            <RadioGroup
              aria-labelledby="sent to ISF choice"
              defaultValue=""
              name="radio-buttons-group"
              onChange={handleRadioValue}
            >
              <FormControlLabel value="newVersion" control={<Radio />} label="Send the document as new version" />
              <FormControlLabel value="overwrite" control={<Radio />} label="Overwrite the document" />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSendToISF} className="grey-btn">
            Cancel
          </Button>
          <Button onClick={handleCloseSend} disabled={!checked}>
            Send
          </Button>
        </DialogActions>
      </PopupComponent>
    </React.Fragment>
  );
};
